import type { MiniGamePageConfig } from '@/app/(football)/[team]/mini-game/_context/types';

export const jbfcConfig: MiniGamePageConfig = {
  game: {
    colors: ['#0b8e67', '#ffd51a'],
    background: {
      color: '#fafffc',
    },
  },
  titleImage: {
    width: 217,
    height: 62,
    alt: '전북현대모터스 미니게임 타이틀',
    marginTop: 72,
  },
  eventPeriod: {
    endDate: '2026-12-31T23:59:59+09:00',
  },
}; 